import { render, staticRenderFns } from "./payment-unsuccessful.vue?vue&type=template&id=82834824&"
import script from "./payment-unsuccessful.vue?vue&type=script&lang=js&"
export * from "./payment-unsuccessful.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports